export default "__VITE_ASSET__C$ybcrre__"